;(function() {
  'use strict'

  angular.module('core.filters', ['glow.services'])
})()
